import type { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';
import type { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Initializes the day grid.
 *
 * The selectedTime should be initialized with Start and End dates in the respective time zones.
 * The day grid will then display time in the Start time zone.
 * It will also show the two time zone headers if the Start and End time zones are different.
 */
export const initializeDayGrid = action(
    'dayGrid-initializeDayGrid',
    (
        scenarioId: string,
        folderIds: string[],
        selectedDate: OwaDate,
        selectionItem: CalendarEvent,
        showSelectionItem: boolean,
        disableTabbableSurfaceItems: boolean,
        daysInDayRange?: number,
        enableDragDrop?: boolean,
        dateRangeType?: DateRangeType | undefined
    ) => ({
        scenarioId,
        folderIds,
        selectedDate,
        selectionItem,
        showSelectionItem,
        disableTabbableSurfaceItems,
        daysInDayRange,
        enableDragDrop,
        dateRangeType,
    })
);
